<template>
    <div>
        <h2>Reset password</h2>
        <p class="mb-4">Enter a new password for your account. We highly recommend you create a unique password.</p>
        <form @submit.prevent="submit">
            <div class="alert alert-success" role="alert" v-if="success">
                {{success}}
            </div>
            <div class="form-label-group">
                <input autocomplete="off" autofocus class="form-control"
                       data-vv-validate-on="blur"
                       id="inputEmail"
                       name="email"
                       placeholder="Email address"
                       type="text"
                       v-bind:class="[this.email.validated ? this.email.valid ? 'is-valid' : 'is-invalid' : '']"
                       v-model="form.email"
                       v-validate="'required|email'">
                <label for="inputEmail">Email address</label>
                <div class="invalid-feedback">{{ errors.first('email') }}</div>
            </div>
            <div class="form-label-group">
                <input autocomplete="off" autofocus class="form-control"
                       data-vv-validate-on="blur"
                       id="inputPassword"
                       name="password"
                       ref="password"
                       placeholder="Password"
                       type="password"
                       v-bind:class="[this.password.validated ? this.password.valid ? 'is-valid' : 'is-invalid' : '']"
                       v-model="form.password"
                       v-validate="'required|min:8'">
                <label for="inputPassword">Password</label>
                <div class="invalid-feedback">{{ errors.first('password') }}</div>
            </div>
            <div class="form-label-group">
                <input autocomplete="off" autofocus class="form-control"
                       id="inputPasswordConf"
                       data-vv-validate-on="blur"
                       name="password_confirmation"
                       placeholder="Password confirmation"
                       type="password"
                       data-vv-as="password confirmation"
                       v-bind:class="[this.password_confirmation.validated ? this.password_confirmation.valid ? 'is-valid' : 'is-invalid' : '']"
                       v-model="form.password_confirmation"
                       v-validate="'required|confirmed:password'">
                <label for="inputPasswordConf">Password confirmation</label>
                <div class="invalid-feedback">{{ errors.first('password_confirmation') }}</div>
            </div>
            <button :disabled="loading"
                    class="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2"
                    type="submit"><span v-if="!loading">Reset password</span>
                <div v-else>
                                            <span aria-hidden="true" class="spinner-border spinner-border-sm"
                                                  role="status"></span>
                    Loading...
                </div>
            </button>
            <div class="text-center">
                <router-link :to="{name: 'login'}" class="small">Back to login page</router-link>
            </div>
        </form>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'

    export default {
        name: 'Forgot',
        data() {
            return {
                success: '',
                form: {
                    email: '',
                    password: '',
                    password_confirmation: '',
                    token: ''
                },
                loading: false
            }
        },
        computed: {
            ...mapFields(['email', 'password', 'password_confirmation'])
        },
        mounted(){
            this.form.token = this.$route.query.token
            this.form.email = this.$route.query.email
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.$store.dispatch('PASSWORD_RESET', this.form)
                            .then((resp) => {
                                this.success = resp.data.message
                                this.form = {}
                                this.$validator.reset()
                                this.loading = false
                            })
                            .catch((error) => {
                                this.loading = false

                                if (error.error) {
                                    this.$validator.errors.add({
                                        field: 'email',
                                        msg: error.error
                                    })
                                    this.fieldsVee.email.valid = false
                                }
                            })
                    }
                })
            }
        }
    }
</script>
